/* La Florentina cart (REQ-CART-1): gift card attributes, age confirmation, checkout validation. Deferred, cart page only.
   Dawn re-renders the `.js-contents` of #main-cart-footer on quantity changes, so everything here uses delegated events. */
(function () {
  'use strict';

  var ATTR_FROM = 'De parte de';
  var ATTR_MESSAGE = 'Mensaje para la tarjeta';
  var ATTR_AGE = 'Mayor de edad';
  var AGE_YES = 'Sí';

  /* The only list of fields that block checkout: the button state and submit validation both read it.
     "Mensaje" is optional (REQ-CART-1, v1.3.16); the age checkbox exists only when the cart has liquor. */
  var REQUIRED_FIELDS = ['[data-lf-cart-from]', '[data-lf-cart-age]'].join(', ');
  var TEXT_FIELDS = '[data-lf-cart-from], [data-lf-cart-message]';

  function root() {
    return document.getElementById('main-cart-footer');
  }

  function find(selector) {
    var footer = root();
    return footer ? footer.querySelector(selector) : null;
  }

  function required() {
    var footer = root();
    return footer ? footer.querySelectorAll(REQUIRED_FIELDS) : [];
  }

  function isValid(field) {
    if (field.type === 'checkbox') return field.checked;
    return field.value.trim() !== '';
  }

  function setError(field, show) {
    var output = document.getElementById(field.id + '-error');
    if (show) {
      field.setAttribute('aria-invalid', 'true');
      if (output) {
        output.textContent = field.getAttribute('data-msg') || '';
        output.hidden = false;
      }
    } else {
      field.removeAttribute('aria-invalid');
      if (output) {
        output.textContent = '';
        output.hidden = true;
      }
    }
  }

  /* The button looks disabled while the form is invalid but stays focusable, so pressing it can show the errors */
  function updateButton() {
    var button = document.getElementById('checkout');
    if (!button) return;
    var invalid = Array.prototype.some.call(required(), function (field) {
      return !isValid(field);
    });
    if (invalid) button.setAttribute('aria-disabled', 'true');
    else button.removeAttribute('aria-disabled');
  }

  function noteText() {
    var from = find('[data-lf-cart-from]');
    var message = find('[data-lf-cart-message]');
    if (!from || !message) return '';
    var fromText = from.value.trim();
    var messageText = message.value.trim();
    if (fromText === '' && messageText === '') return '';
    /* A blank message is written out on purpose, so the team knows the card goes with the sender's name only */
    if (messageText === '') messageText = message.getAttribute('data-lf-note-empty') || '';
    return (
      from.getAttribute('data-lf-note-label') + ': ' + fromText + '\n' +
      message.getAttribute('data-lf-note-label') + ': ' + messageText
    );
  }

  function syncNote() {
    var note = find('[data-lf-cart-note]');
    if (note) note.value = noteText();
  }

  function save() {
    var from = find('[data-lf-cart-from]');
    var message = find('[data-lf-cart-message]');
    var age = find('[data-lf-cart-age]');
    if (!from || !message) return;
    var attributes = {};
    attributes[ATTR_FROM] = from.value;
    attributes[ATTR_MESSAGE] = message.value;
    attributes[ATTR_AGE] = age && age.checked ? AGE_YES : '';
    var url = (window.routes && window.routes.cart_update_url) || '/cart/update.js';
    fetch(url, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes, note: noteText() })
    }).catch(function () {
      /* the native form post at checkout still carries the same values */
    });
  }

  var saveTimer;
  function saveSoon() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(save, 400);
  }

  document.addEventListener('input', function (event) {
    var field = event.target;
    if (!field.matches || !field.matches(TEXT_FIELDS)) return;
    if (field.matches(REQUIRED_FIELDS) && field.getAttribute('aria-invalid') && isValid(field)) setError(field, false);
    syncNote();
    updateButton();
    saveSoon();
  });

  document.addEventListener('focusout', function (event) {
    var field = event.target;
    if (!field.matches || !field.matches(TEXT_FIELDS)) return;
    if (field.matches(REQUIRED_FIELDS)) setError(field, !isValid(field));
    clearTimeout(saveTimer);
    save();
  });

  window.addEventListener('pagehide', function () {
    clearTimeout(saveTimer);
    save();
  });

  document.addEventListener('change', function (event) {
    var field = event.target;
    if (!field.matches || !field.matches('[data-lf-cart-age]')) return;
    if (field.checked) setError(field, false);
    updateButton();
    save();
  });

  /* Validation also runs on submit, so enabling the button in the browser tools cannot skip it */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.id !== 'cart') return;
    var firstInvalid = null;
    Array.prototype.forEach.call(required(), function (field) {
      var ok = isValid(field);
      setError(field, !ok);
      if (!ok && !firstInvalid) firstInvalid = field;
    });
    if (firstInvalid) {
      event.preventDefault();
      firstInvalid.focus();
      return;
    }
    syncNote();
  });

  /* After Dawn re-renders the totals area: refresh the button, and clear the saved age attribute when no liquor is left */
  var renderTimer;
  function afterRender() {
    updateButton();
    var ageRoot = find('[data-lf-age-root]');
    if (ageRoot && ageRoot.getAttribute('data-lf-age-saved') === 'true' && !find('[data-lf-cart-age]')) {
      ageRoot.setAttribute('data-lf-age-saved', 'false');
      save();
    }
  }

  function start() {
    var form = document.getElementById('cart');
    if (form) form.noValidate = true;
    syncNote();
    afterRender();
    var footer = root();
    if (footer && 'MutationObserver' in window) {
      new MutationObserver(function () {
        clearTimeout(renderTimer);
        renderTimer = setTimeout(afterRender, 50);
      }).observe(footer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
